var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    opacity: 0.6
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 2.49984C16.6663 2.0396 16.2932 1.6665 15.833 1.6665H4.16634C3.7061 1.6665 3.33301 2.0396 3.33301 2.49984V17.4998C3.33301 17.9601 3.7061 18.3332 4.16634 18.3332H9.99967V16.6665H4.99967V3.33317H14.9997V8.33317H16.6663V2.49984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7556 13.5772L16.0056 9.82725L14.8271 11.0058L17.1545 13.3332H9.99967V14.9998H17.1545L14.8271 17.3272L16.0056 18.5058L19.7556 14.7558C20.081 14.4303 20.081 13.9027 19.7556 13.5772Z",
    fill: "white"
  })));
};
export { SvgExport as ReactComponent };
export default __webpack_public_path__ + "assets/2fdd3ee1.svg";